/* eslint-disable @typescript-eslint/explicit-member-accessibility */
export class HistoryModel {

    isComment: boolean

}
